var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "experience-sign" }, [
      _c("form", [
        _c(
          "h1",
          { staticClass: "f-weight__500 text-center font-small title" },
          [_vm._v("体验签署")]
        ),
        _c("div", { staticClass: "title-img" }, [
          _c("img", {
            attrs: { src: require("../../static/images/tpl/logo.png") }
          })
        ]),
        _c("div", { staticClass: "ms mb30" }, [
          _vm._v("【本次签署仅作演示体验使用，无法律效力】")
        ]),
        _c("p", [
          _c("strong", [
            _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
              _vm._v("       君子签")
            ])
          ]),
          _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
            _vm._v(
              "是易保全旗下国内专业的区块链电子签署平台，以领先的区块链技术为基础，结合全证据链原创技术，通过改造传统签署模式，打造“区块链+司法+电子签署”创新模式，主要为金融、教培、人力资源、房地产、物流运输、供应链、医疗医药、电子政务等行业企业及政府机构，提供"
            )
          ]),
          _c("strong", [
            _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
              _vm._v(
                "“实名认证、在线签署、合同智能管理、电子签章、区块链存证、全证据链保全、司法服务”"
              )
            ])
          ]),
          _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
            _vm._v(
              "等一站式电子签署服务及行业定制化解决方案，能够有效解决传统纸质合同"
            )
          ]),
          _c("strong", [
            _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
              _vm._v("“签署效率低、成本高、管理难、风险大”")
            ])
          ]),
          _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
            _vm._v("等痛点，赋能企业降本提效，节能安全，实现数字化转型升级。")
          ])
        ]),
        _c("p", [
          _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [_c("br")])
        ]),
        _c("p", { staticStyle: { "text-align": "center", margin: "5px 0" } }, [
          _c("strong", [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("3大环节12大服务")]
            )
          ])
        ]),
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("strong", [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("区块链全生命周期电子合同服务")]
            )
          ])
        ]),
        _c("p", { staticStyle: { "text-align": "center", margin: "5px 0" } }, [
          _c("img", {
            attrs: {
              width: "554",
              height: "272",
              src: require("../../static/images/tpl/expro1.png")
            }
          }),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v(" ")]
          )
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("      君子签目前已获得国家网信办")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("区块链信息服务备案")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v("（备案号：渝网信备")
              ]),
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v("50011220697819890019号）、ISO27001信息安全管")
              ])
            ]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("理")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("认证")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("和公安部等保三级认证（金融级别）")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("，并与")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("国内多家")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("公证处、")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("互联网法院、仲裁委、")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("律所")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("等")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("建立合作，提供完善的")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("司法保障")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("服务")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("体系，让合同签署更加高效便捷、安全合规")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("。")]
          )
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v("截止到")
              ]),
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v(
                  "2021年6月，君子签累计签署量突破22亿，日均签署量突破400万，已服务7400万+用户，典型客户包括中国农业银行、中建投租赁、国药集团、华宇集团、旭辉集团、韵达集团、富士康、重庆建工集团、新疆旅游局、分众传媒、拉卡拉、忽米网等。"
                )
              ])
            ]
          )
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _c("br")
              ])
            ]
          )
        ]),
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("strong", [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("    核心优势")]
            )
          ])
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v("      保全链开放平台")
              ]),
              _c("span", { staticStyle: { "font-family": "微软雅黑" } }, [
                _vm._v(
                  "——是由易保全电子数据保全中心结合区块链技术和自主发明专利，联合公证处、仲裁委、司法鉴定所、版权机构、数字认证中心、法院等机构组建的联盟区块链平台。客户上传的数据会同步储存至10+权威机构节点服务器，实现同步收录采信，保证存证数据不可篡改，确保电子数据成为合法有效的电子证据。"
                )
              ])
            ]
          )
        ]),
        _c("p", { staticStyle: { "text-align": "center", margin: "5px 0" } }, [
          _c("img", {
            attrs: {
              width: "381",
              height: "257",
              src: require("../../static/images/tpl/expro2.png")
            }
          }),
          _c("strong", [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v(" ")]
            )
          ])
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "宋体", "font-size": "14px" } },
            [_vm._v(" ")]
          )
        ]),
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("strong", [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("    全证据链")]
            )
          ])
        ]),
        _c("p", [
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [
              _vm._v(
                "      君子签通过签署全证据链原创技术，可以记录用户签署产生的全过程关键细节，包括签署终端、时间、地理位置、现场音视频、人脸识别视频存证等，有效保障合同"
              )
            ]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("信息安全，")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("合同")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("签署合规有效")]
          ),
          _c(
            "span",
            { staticStyle: { "font-family": "微软雅黑", "font-size": "16px" } },
            [_vm._v("。")]
          )
        ]),
        _c("p", { staticStyle: { "text-align": "center", margin: "5px 0" } }, [
          _c("img", {
            attrs: {
              width: "552",
              height: "151",
              src: require("../../static/images/tpl/expro3.png")
            }
          }),
          _c(
            "span",
            { staticStyle: { "font-family": "宋体", "font-size": "14px" } },
            [_vm._v(" ")]
          )
        ]),
        _c(
          "p",
          { staticStyle: { "margin-right": "0", "margin-bottom": "0" } },
          [
            _c(
              "span",
              { staticStyle: { "font-family": "宋体", "font-size": "14px" } },
              [_vm._v(" ")]
            )
          ]
        ),
        _c(
          "p",
          {
            staticStyle: {
              "margin-right": "0px",
              "margin-bottom": "0px",
              "text-align": "center"
            }
          },
          [
            _c("strong", [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-family": "微软雅黑",
                    "font-size": "16px"
                  }
                },
                [_vm._v("    司法服务能力")]
              )
            ])
          ]
        ),
        _c(
          "p",
          { staticStyle: { "margin-right": "0", "margin-bottom": "0" } },
          [
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("      与")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("权威司法机构")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("系统底层互通")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("，存证的电子数据")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("与司法机构同步存储、同步存证，并可实时查询验证，")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("若遇纠纷，")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("可在线出具")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("公证处")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("、")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("仲裁委")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("、")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("互联网法院等司法机构直接采信")]
            ),
            _c(
              "span",
              {
                staticStyle: { "font-family": "微软雅黑", "font-size": "16px" }
              },
              [_vm._v("的电子证据。")]
            )
          ]
        ),
        _c("p", [
          _c("img", {
            attrs: {
              width: "620",
              src: require("../../static/images/tpl/expro4.png")
            }
          }),
          _c(
            "span",
            { staticStyle: { "font-family": "Calibri", "font-size": "14px" } },
            [_vm._v(" ")]
          )
        ]),
        _c("p", [_c("br")]),
        _c("div", { staticClass: "bottom-img" }, [
          _c("div", [
            _c("img", {
              staticClass: "mb20",
              attrs: { src: require("../../static/images/tpl/qr1.png") }
            }),
            _c("br"),
            _vm._v("\n        2分钟了解君子签\n      ")
          ]),
          _c("div", [
            _c("img", {
              staticClass: "mb20",
              attrs: { src: require("../../static/images/tpl/qr2.png") }
            }),
            _c("br"),
            _vm._v("\n        2关注官方公众号\n      ")
          ])
        ]),
        _c("div", { staticClass: "cel mt60 pd10" }, [
          _c("div", { staticClass: "cel-content font-bold" }, [
            _vm._v("签署体验人盖章：")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85ec9570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85ec9570","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/exper.vue
// module id = SdQq
// module chunks = 57